import {TableSettings} from '../../../tableSettings';

export const airExportMawbList:TableSettings = {
  tableVersion: 100601,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};

export const airExportVolumeWeight:TableSettings = {
  tableVersion: 1018,
  overflowX: 'hidden',
  overflowY: 'scroll',
  flexResizer: true,
  alternateRows: false,
  columns: [
    { accessor:'indicator', Header: '#', visible: true, resizable: false, sortable: false, initialWidthPercentage: 8.33, },
    { accessor:'length', Header: 'Length', visible: true, resizable: false, sortable: false, initialWidthPercentage: 13.89, },
    { accessor:'width', Header: 'Width', visible: true, resizable: false, sortable: false, initialWidthPercentage: 13.89, },
    { accessor:'height', Header: 'Height', visible: true, resizable: false, sortable: false, initialWidthPercentage: 13.89, },
    { accessor:'pcs', Header: 'Pkgs', visible: true, resizable: false, sortable: false, initialWidthPercentage: 13.89, },
    { accessor:'chgWeight', Header: 'Chrg KGS', visible: true, resizable: false, sortable: false, initialWidthPercentage: 15.28, },
    { accessor:'lChgWeight', Header: 'Chrg LBS', visible: true, resizable: false, sortable: false, initialWidthPercentage: 15.28, },
    { accessor:'scroll', Header: '', visible: true, resizable: false, sortable: false, initialWidthPercentage: 5.55, },
  ]
};

export const hawbBlDetailsHawbBody: TableSettings = {
  tableVersion: 1012,
  overflowX: 'hidden',
  overflowY: 'scroll',

  height: '170px',
  flexResizer: true,

  columns: [
    {
      Header: 'Billing Code',
      accessor: 'chgCodeName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.56,
    },
    {
      Header: 'Item Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 26.6,
    },
    {
      Header: 'Revenue',
      accessor: 'preRevenue',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.33,
    },
    {
      Header: 'Cost',
      accessor: 'preCost',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.33,
    },
    {
      Header: 'Revenue',
      accessor: 'colRevenue',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.33,
    },
    {
      Header: 'Cost',
      accessor: 'colCost',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.33,
    },
    {
      Header: 'A',
      accessor: 'agentShow',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.07,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.08,
    },
  ]
};

export const airExportChargeableItems:TableSettings = {
  tableVersion: 1019,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '100%',
  flexResizer: true,

  alternateRows: true,
  columns: [
    { accessor: 'chargeableItem', Header: 'Chargeable Item', visible: true, resizable: false, hideTooltip: true, sortable: false, initialWidthPercentage: 56.76, },
    { accessor: 'prepaid', Header: 'Prepaid', visible: true, resizable: false, sortable: false, hideTooltip: true, initialWidthPercentage: 21.62, },
    { accessor: 'collect', Header: 'Collect', visible: true, resizable: false, sortable: false, hideTooltip: true, initialWidthPercentage: 21.62, },
    // { accessor:'scroll', Header: '', visible: true, resizable: false, sortable: false, initialWidthPercentage: 5.0, },
  ]
};

export const airExportHawbList:TableSettings = {
  tableVersion: 1035,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};

export const airExportFaceRate:TableSettings = {
  tableVersion: 1018,
  overflowX: 'hidden',
  overflowY: 'hidden',

  flexResizer: true,

  alternateRows: true,
  columns: [
    { accessor:'no', Header: 'Package(s)', visible: true, resizable: false, sortable: false, initialWidthPercentage: 14.15, },
    { accessor:'gw', Header: 'Gross Weight', visible: true, resizable: false, sortable: false, initialWidthPercentage: 14.15, },
    { accessor:'kg', Header: 'KG LB', visible: true, resizable: false, sortable: false, initialWidthPercentage: 5.66, },
    { accessor:'rateClass', Header: 'Rate Class', visible: true, resizable: false, sortable: false, initialWidthPercentage: 7.54, },
    { accessor:'commodity', Header: 'Commodity Item #', visible: true, resizable: false, sortable: false, initialWidthPercentage: 14.15, },
    { accessor:'chw', Header: 'Chargeable Weight', visible: true, resizable: false, sortable: false, initialWidthPercentage: 14.15, },
    { accessor:'r', Header: 'Rate / Charge', visible: true, resizable: false, sortable: false, initialWidthPercentage: 15.09, },
    { accessor:'total', Header: 'Total', visible: true, resizable: false, sortable: false, initialWidthPercentage: 15.09, },
  ]
};

export const airExportHawbFaceRate:TableSettings = {
  tableVersion: 1011,
  overflowX: 'hidden',
  overflowY: 'hidden',
  flexResizer: true,

  alternateRows: true,
  columns: [
    { accessor:'no', Header: 'Package(s)', visible: true, resizable: false, sortable: false, initialWidthPercentage: 11.76, },
    { accessor:'gw', Header: 'Gross Weight', visible: true, resizable: false, sortable: false, initialWidthPercentage: 15.69, },
    { accessor:'kg', Header: 'KG LB', visible: true, resizable: false, sortable: false, initialWidthPercentage: 7.83, },
    { accessor:'commodity', Header: 'Commodity Item #', visible: true, resizable: false, sortable: false, initialWidthPercentage: 17.65, },
    { accessor:'chw', Header: 'Chargeable Weight', visible: true, resizable: false, sortable: false, initialWidthPercentage: 15.69, },
    { accessor:'r', Header: 'Rate / Charge', visible: true, resizable: false, sortable: false, initialWidthPercentage: 15.69, },
    { accessor:'total', Header: 'Total', visible: true, resizable: false, sortable: false, initialWidthPercentage: 15.69, },
  ]
};

export const hawbAeHblPoBodyLineItems:TableSettings = {
  tableVersion: 1014,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '300px',
  flexResizer: true,

  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.63, },
    { Header: 'PO #', accessor: 'poNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: 'SKU', accessor: 'skuNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 13.16, },
    { Header: 'HTS Code', accessor: 'htsCode', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.02, },
    { Header: 'C/O', accessor: 'coo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: 'Description', accessor: 'description', resizable: false, sortable: false, visible: true, initialWidthPercentage: 15.79, },
    { Header: 'Qty', accessor: 'shipQty', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: 'Unit', accessor: 'shipUnit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.02, },
    { Header: 'Unit Price', accessor: 'uPrice', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: 'KGS (G)', accessor: 'kgs', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: 'KGS (C)', accessor: 'cKgs', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 1.76, },
  ]
};

export const batchPrintTable:TableSettings = {
  tableVersion: 10048,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  flexResizer: true,

  columns: [
    {
      Header: '',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.41,
    },
    {
      Header: 'HAWB #',
      accessor: 'hblNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.17,
    },
    {
      Header: 'Shipper',
      accessor: 'shipperFullName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.59,
    },
    {
      Header: 'Fax',
      accessor: 'hasShipperFax',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Email',
      accessor: 'hasShipperEmail',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Customer',
      accessor: 'customerName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.59,
    },
    {
      Header: 'Agent',
      accessor: 'agentName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.65,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.94,
    },
  ]
};

export const airExportQuotationList:TableSettings = {
  tableVersion: 10051,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    { accessor:'status', Header: '', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'quoteNo', Header: 'Quotation #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'quoteDate', Header: 'Date', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'operator', Header: 'Quote By', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'validBy', Header: 'Valid By', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'customer', Header: 'Customer', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'contactName', Header: 'Contact', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text',  },
    // { accessor:'hBookingNo', Header: 'Cust. Book Rqst No', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'serviceType', Header: 'Service Type', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'commodity', Header: 'Commodity', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'plofRec', Header: 'Place of Receipt', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'loadingPort', Header: 'Departure Airport', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'discharge', Header: 'Arrival Airport', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'sManID', Header: 'Salesperson', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Updated', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Created', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

